export default __webpack_public_path__ + "static/media/pimeoBlue.f4a319c0.svg";